import { msg } from '~/utils/validation';
import { z } from 'zod';
import { RoleEnum } from '~/apis/ssf';

export const schema = z.object({
  group: z
    .string()
    .min(1, { message: msg.required })
    .transform(s => Number(s)),
  role: z
    .string()
    .min(1, { message: msg.required })
    .transform(s => s as RoleEnum),
});

export type Schema = z.infer<typeof schema>;
